<template>
    <div style="margin-top:0px">
        <FeedListComponent :section="'group'" :isAdmin="isAdmin" :isModeration="isAdmin"></FeedListComponent>
    </div>
</template>

<script>
import FeedListComponent from '@/components/FeedListComponent'
export default {
    components:{FeedListComponent},
    props:{
            isAdmin: {
            type: [Boolean, String],
            required: false,
            default: ''
        }
    }
}
</script>

<style>

</style>
